import { useCallback, useMemo } from 'react';
import uuid from 'react-uuid';
import Button from 'src/components/design-system/Button';
import useViewCheckbook from 'src/hooks/useViewCheckbook';
import useYearView from 'src/hooks/useYearView';
import { GLCodeYearDepartment } from 'src/services/useGlCodeDepartmentApi';

const AddGlCode = () => {
  const {
    setYearCheckbookDataState,
    isEditMode,
    setEditingGlCodeYearBudget,
    setOriginalGlCodeYearBudget,
    setIsEditMode,
    dropDownYearValue,
    glPeriods,
  } = useViewCheckbook();

  const { yearViewData, yearViewDropdownFilter } = useYearView();

  const handleAddGLCode = useCallback(() => {
    const periods = glPeriods
      .filter((period) => period.fiscalYear === dropDownYearValue?.fiscalYear)
      .sort((a, b) => {
        const dateA: Date = new Date(a.startDate);
        const dateB: Date = new Date(b.startDate);
        return dateA.getTime() - dateB.getTime();
      });

    const combinedPeriods = periods.reduce((result, item, index) => {
      const key = `period${(index + 1).toString().padStart(2, '0')}`;
      const key2 = `budgetPeriod${(index + 1).toString().padStart(2, '0')}`;
      const key3 = `initialBudgetPeriod${(index + 1).toString().padStart(2, '0')}`;
      const key4 = `_initialBudgetPeriod${(index + 1).toString().padStart(2, '0')}`;

      result[key] = 0;
      result[key2] = 0;
      result[key3] = null;
      result[key4] = null;
      return result;
    }, {} as Record<string, number | null>);
    const newData = {
      id: Math.random(),
      code: '',
      departments: [] as GLCodeYearDepartment[],
      description: '',
      remainingBudgetAmountPercentage: 0,
      budgetAmount: 0,
      holdAmount: 0,
      spentAmount: 0,
      initialBudget: null,
      isActive: true,
      isDeleted: false,
      remainingBudgetAmount: 0,
      hasHoldTransactionData: true,
      hasSpentTransactionData: true,
      isFixed: true,
      selected: false,
      isNewGlCode: true,
      rowId: uuid(),
      ...combinedPeriods,
      periodBudgets: periods?.map((period) => ({
        glPeriodId: period?.glPeriodId,
        startDate: period.startDate,
        endDate: period.endDate,
        totalBudgetAmount: 0,
        initialBudget: null,
      })),
    };

    document.querySelector('.k-grid-content.k-virtual-content')?.scrollTo({ top: 0 });

    if (isEditMode) {
      setEditingGlCodeYearBudget((prev) => [newData, ...prev]);
    } else {
      const data = [newData, ...yearViewData];
      setEditingGlCodeYearBudget(data);
      setOriginalGlCodeYearBudget(data);
    }

    setYearCheckbookDataState((prev) => ({ ...prev, skip: 0 }));
    setIsEditMode(true);
  }, [
    dropDownYearValue?.fiscalYear,
    glPeriods,
    isEditMode,
    setEditingGlCodeYearBudget,
    setIsEditMode,
    setOriginalGlCodeYearBudget,
    setYearCheckbookDataState,
    yearViewData,
  ]);

  const isAddHidden = useMemo(
    () => yearViewDropdownFilter.value === 4,
    [yearViewDropdownFilter.value]
  );

  return isAddHidden ? (
    <></>
  ) : (
    <Button onClick={handleAddGLCode} color="primary">
      Add New GL Code
    </Button>
  );
};

export default AddGlCode;
